// @flow
import * as React from 'react';
import styled from 'styled-components';

import { ButtonSecondaryLink } from '../ButtonSecondary';

import colors from '../../assets/css/colors';

const MessageText = styled.h4`
	font-size: 15px;
	line-height: 1.5;
	font-weight: bold;
	text-align: center;
	color: ${colors.darkGrey};
	margin-bottom: 20px;
`;

const Wrapper = styled.div`
	background: white;
	padding: 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

type Props = {
	league_id: number
}

const FinalRoundNotDeterminedMessage = ({ league_id }: Props) => (
	<Wrapper>
		<MessageText>Finals Fixtures for your league are yet to be determined</MessageText>
		<ButtonSecondaryLink to={`/league/${league_id}/`}>
			Go to your League Overview
		</ButtonSecondaryLink>
	</Wrapper>
);

export default FinalRoundNotDeterminedMessage;


// WEBPACK FOOTER //
// ./src/components/Fixtures/FinalRoundNotDeterminedMessage.js